module.exports = __webpack_public_path__ + "static/media/avatar.4de739d7.png";